// Average trust in others (rating 0-10), population aged 16 and over.
// Source: Eurostat, "Trust in others by sex, age and educational attainment"
// (ilc_pw03), comparing 2013 with 2025.
// Ordered as in the European Correspondent visualization: Central and Eastern
// European trust rose, while it fell across much of the West.
export const europeanYouthTrust = [
  { country: 'Croatia', trust2025: 6.6, trust2013: 5.1 },
  { country: 'Romania', trust2025: 7.5, trust2013: 6.4 },
  { country: 'Poland', trust2025: 6.9, trust2013: 6.0 },
  { country: 'Slovakia', trust2025: 6.1, trust2013: 5.8 },
  { country: 'Ireland', trust2025: 6.7, trust2013: 6.4 },
  { country: 'Italy', trust2025: 6.1, trust2013: 5.7 },
  { country: 'Latvia', trust2025: 6.1, trust2013: 6.5 },
  { country: 'Belgium', trust2025: 6.2, trust2013: 5.7 },
  { country: 'Serbia', trust2025: 5.5, trust2013: 4.2 },
  { country: 'Spain', trust2025: 6.2, trust2013: 6.3 },
  { country: 'Finland', trust2025: 7.0, trust2013: 7.4 },
  { country: 'Luxembourg', trust2025: 5.6, trust2013: 5.5 },
  { country: 'Netherlands', trust2025: 6.7, trust2013: 6.9 },
  { country: 'Bulgaria', trust2025: 5.4, trust2013: 4.2 },
  { country: 'Czechia', trust2025: 5.3, trust2013: 5.3 },
  { country: 'Greece', trust2025: 5.1, trust2013: 5.3 },
  { country: 'Germany', trust2025: 5.6, trust2013: 5.5 },
  { country: 'Estonia', trust2025: 5.3, trust2013: 5.8 },
  { country: 'Hungary', trust2025: 5.3, trust2013: 5.3 },
  { country: 'Portugal', trust2025: 5.5, trust2013: 5.3 },
  { country: 'Norway', trust2025: 6.0, trust2013: 7.3 },
  { country: 'Austria', trust2025: 5.4, trust2013: 5.8 },
  { country: 'Denmark', trust2025: 5.7, trust2013: 8.3 },
  { country: 'Lithuania', trust2025: 4.4, trust2013: 6.1 },
  { country: 'Malta', trust2025: 5.0, trust2013: 6.2 },
  { country: 'Sweden', trust2025: 5.6, trust2013: 6.8 },
  { country: 'Slovenia', trust2025: 4.6, trust2013: 6.5 },
  { country: 'Cyprus', trust2025: 3.5, trust2013: 4.5 },
  { country: 'Türkiye', trust2025: 3.3, trust2013: 4.5 },
  { country: 'France', trust2025: 4.0, trust2013: 5.0 },
];

// Eurostat EU27 (2020 composition) average for 2025.
export const euAverageTrust2025 = 5.8;
